"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableControls = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TableControls = _ref => {
  let {
    saveLabel = 'Save',
    onSaveHandler,
    resetLabel = 'Reset',
    onResetHandler
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "tableControls"
  }, onResetHandler && /*#__PURE__*/_react.default.createElement("button", {
    className: "button primary inverse",
    type: "button",
    onClick: onResetHandler
  }, resetLabel), onSaveHandler && /*#__PURE__*/_react.default.createElement("button", {
    className: "button primary",
    type: "button",
    onClick: onSaveHandler
  }, saveLabel));
};
exports.TableControls = TableControls;
TableControls.propTypes = {
  saveLabel: _propTypes.default.string,
  onSaveHandler: _propTypes.default.func,
  resetLabel: _propTypes.default.string,
  onResetHandler: _propTypes.default.func
};